import React, {createContext, useEffect, useState} from 'react';
import axios from "axios";
import {useMediaQuery} from 'react-responsive';
import {config} from "../../config";

const SettingsContext = createContext({});

export const SettingsProvider = ({children}) => {

	const [siteMap,setSiteMap] = useState(null);
	const [settingsData,setSettingsData] = useState({});

	const isDesktop = useMediaQuery({
		query: '(min-width: 769px)'
	});
	const isMobile = useMediaQuery({
		query: '(max-width: 768px)'
	});



	useEffect( () => {
		axios
			.get(config.domainRelPath+'/wp-json/acf/v3/options/acf-options-settings')
			.then( res => {
				setSettingsData( res?.data?.acf );
			} )
			.catch(error => console.log(error));

		axios
			.get(
				config.domainRelPath+'/wp-json/wp/v2/pages/?per_page=100&orderby=menu_order&order=asc'
			)
			.then(res => {
				const sitemapData = res.data
					.filter(page=>page.id!==6)
					.map(page=>{
						const {id,slug,status,parent,title,link} = page;
						return {
							id,
							link,
							slug,
							status,
							parent,
							title:title.rendered
						}
					});
				setSiteMap(sitemapData);
			})
			.catch(error => console.log(error));
	},[
		setSettingsData,
		setSiteMap
	])
	return (
		<SettingsContext.Provider value={{
			isDesktop,
			isMobile,
			settingsData,
			siteMap
		}}>
			{children}
		</SettingsContext.Provider>
	);
};

export default SettingsContext;